(function () {
  'use strict';

  // The scale service links (snippets/biztracker-scale-service.liquid) carry the scale they are
  // about. Map the link's short service key onto the option the form actually offers.
  var SERVICE_LABELS = {
    'calibration': 'Calibration / legal-for-trade',
    'installation-setup': 'Installation / setup'
  };

  function setSelect(select, wanted) {
    var match = Array.prototype.some.call(select.options, function (option) {
      return option.value === wanted;
    });
    if (!match) return;
    select.value = wanted;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function prefill() {
    if (!window.URLSearchParams) return;
    var params = new URLSearchParams(window.location.search);
    var topic = params.get('topic');

    if (topic) {
      var selects = document.querySelectorAll('[data-bt-topic-select]');
      Array.prototype.forEach.call(selects, function (select) {
        setSelect(select, topic);
      });
    }

    var service = SERVICE_LABELS[params.get('service')];
    if (service) {
      var needed = document.querySelector('select[name="contact[Service Needed]"]');
      if (needed) setSelect(needed, service);
    }

    // The scale's make and model go into the visible Scale Model field so the visitor can correct
    // them; the lead snippet reads whatever the field holds at submit time.
    var model = (params.get('model') || '').trim().slice(0, 120);
    var manufacturer = (params.get('manufacturer') || '').trim().slice(0, 60);
    if (model) {
      var field = document.querySelector('input[name="contact[Scale Model]"]');
      var named = manufacturer && model.toLowerCase().indexOf(manufacturer.toLowerCase()) !== 0;
      if (field && !field.value) field.value = (named ? manufacturer + ' ' : '') + model;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefill);
  } else {
    prefill();
  }
})();
